<template>
  <div class="tips-dialog">
    <el-dialog :class="customClass" :visible.sync="visible" :title="title" @opened="opened()" @close="close()"
               @cancel="cancel()" :destroy-on-close="true" :append-to-body="appendToBody" :show-close="ifShowClose"
               :before-close="cancel">
      <zwx-scrollbar-y class="dialog-scrollbar-y">
        <slot />
      </zwx-scrollbar-y>
      <div slot="footer" style="display: flex; align-items: center;"
           :style="ifFooterSlot?'justify-content: space-between;':'justify-content:flex-end;'" v-if="ifFooter">
        <slot name="footer" />
        <div>
          <el-button class="zwx-button zwx-button-32" v-if="ifCancel" @click="cancel()">{{ cancelText }}</el-button>
          <el-button class="zwx-button zwx-button-32" v-if="ifDetermine" type="primary" @click="determine()"
                     :disabled="ifDetermineDis">{{ determineText }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "TipsDialog",
  components: {},
  props: {
    title: { type: String, default: "" },
    customClass: { type: String, default: "" },
    ifFooter: { type: Boolean, default: true },
    ifDetermine: { type: Boolean, default: true },
    ifCancel: { type: Boolean, default: true },
    appendToBody: { type: Boolean, default: false },
    ifShowClose: { type: Boolean, default: true },
    ifFooterSlot: { type: Boolean, default: false },
    ifDetermineDis: { type: Boolean, default: false },
    determineText: { type: String, default: "确定" },
    cancelText: { type: String, default: "取消" }
  },
  data() {
    return {
      visible: false
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    show(visible) {
      this.visible = visible;
    },
    determine() {
      this.$emit("determine");
    },
    cancel() {
      this.$emit("cancel");
    },
    opened() {
      this.$emit("opened");
    },
    close() {
      this.$emit("close");
      this.visible = false;
    }
  }
};
</script>

<style scoped lang="less">
.tips-dialog {
  .dialog-scrollbar-y .el-scrollbar__wrap {
    max-height: 64vh !important;
  }

  /deep/ .el-dialog {
    width: 420px !important;
    min-width: unset !important;
    margin-top: 43.5vh !important;
    border-radius: 4px !important;
    border: 1px solid #ebeef5 !important;
  }

  /deep/ .el-dialog__header {
    height: 43px !important;
    line-height: 43px !important;
    background: transparent !important;
    box-shadow: unset !important;
    padding: 3px 0 0 15px !important;
  }

  /deep/ .el-dialog__headerbtn {
    top: 14px !important;
    right: 14px !important;
  }

  /deep/ .el-dialog__title {
    font-size: 18px !important;
    color: #303133 !important;
  }

  /deep/ .el-dialog__footer {
    border-top: none !important;
    padding: 7px 15px 7px !important;
  }

  /deep/ .el-icon-warning:before {
    color: #e6a23c;
    font-size: 24px !important;
  }
}
</style>
